export default __webpack_public_path__ + "static/media/specs-3.dc487fe7.png";